import { render } from "./NavTabs.vue?vue&type=template&id=2401b66a&scoped=true&ts=true"
import script from "./NavTabs.vue?vue&type=script&lang=ts"
export * from "./NavTabs.vue?vue&type=script&lang=ts"

import "./NavTabs.vue?vue&type=style&index=0&id=2401b66a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2401b66a"]])

export default __exports__